<template>
  <div>
    <!-- Start: Content -->
    <section class="reservation-info" v-if="!isLoading">
      <div class="container">
        <div class="row">
          <div class="col-sm-7">
            <div class="header--reservation-detail">
              <div class="header--reservation-box">
                <nav aria-label="breadcrumb">
                  <ol class="breadcrumb mb-35 pz">
                    <li class="breadcrumb-item">
                      <router-link to="/report/inquiry-reservation">
                        Manage Booking
                      </router-link>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">
                      Invoice
                    </li>
                  </ol>
                </nav>
                <h4>Booking Detail</h4>
                <div class="table-legend">
                  <ul>
                    <li v-if="isAirportTransfer">
                      <i class="ic-flight-icon"></i>Airport Transfer
                    </li>
                    <li v-else><i class="ic-time"></i>Hourly Booking</li>
                  </ul>
                </div>
              </div>
              <div class="label-group">
                <div class="label">Payment Status</div>
                <div class="label-title">
                  <span
                    :class="{
                      '--green35': detail.paymentStatus === 'Complete',
                      'sts-danger': detail.paymentStatus !== 'Complete',
                    }"
                    >{{ detail.paymentStatus }}</span
                  >
                </div>
              </div>
              <div class="label-group">
                <div class="label">Reservation Code</div>
                <div class="label-title">
                  <span>{{ detail.code }}</span>
                </div>
              </div>
              <div class="label-group">
                <div class="label">Reservation Date</div>
                <div class="label-title">
                  <span>{{ detail.reservationDate.stringFullDate }} </span>
                </div>
              </div>
            </div>
            <div class="body--reservation-detail">
              <div class="row">
                <div class="col-sm-6">
                  <i class="ic-businessmen pull-left mr-10"></i>
                  <h4>Bookers</h4>
                  <div class="label-group">
                    <div class="label">Name</div>
                    <div class="label-title">
                      {{ detail.booker.title }}. {{ detail.booker.fullName }}
                    </div>
                  </div>
                  <div class="label-group">
                    <div class="label">Phone</div>
                    <div class="label-title">
                      (+{{ detail.booker.phoneCode }})
                      {{ detail.booker.phoneNumber }}
                    </div>
                  </div>
                  <div class="label-group">
                    <div class="label">Email</div>
                    <div class="label-title">{{ detail.booker.email }}</div>
                  </div>
                  <div
                    class="label-group"
                    v-if="
                      detail.booker.residentAddress !== undefined &&
                      detail.booker.residentAddress !== null
                    "
                  >
                    <div class="label">Resident Address</div>
                    <div class="label-title">
                      {{ detail.booker.residentAddress }}
                    </div>
                  </div>
                  <div
                    class="label-group"
                    v-if="
                      detail.booker.identityNumber !== undefined &&
                      detail.booker.identityNumber !== null
                    "
                  >
                    <div class="label">ID Card</div>
                    <div class="label-title">
                      {{ detail.booker.identityNumber }}
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 divider-left text-right">
                  <h4>Passenger Information</h4>
                  <div class="label-group">
                    <div class="label">Name</div>
                    <div class="label-title">
                      {{ detail.passengers[0].title }}.
                      {{ detail.passengers[0].fullName }}
                    </div>
                  </div>
                  <div class="label-group">
                    <div class="label">Phone</div>
                    <div class="label-title">
                      (+{{ detail.passengers[0].phoneCode }})
                      {{ detail.passengers[0].phoneNumber }}
                    </div>
                  </div>
                  <div class="label-group">
                    <div class="label">Email</div>
                    <div class="label-title">
                      {{ detail.passengers[0].email }}
                    </div>
                  </div>
                  <div
                    class="label-group"
                    v-if="
                      detail.passengers[0].location !== undefined &&
                      detail.passengers[0].location !== null
                    "
                  >
                    <div class="label">Resident Address</div>
                    <div class="label-title">
                      {{ detail.passengers[0].location.address }}
                    </div>
                  </div>
                  <div
                    class="label-group"
                    v-if="
                      detail.passengers[0].identityNumber !== undefined &&
                      detail.passengers[0].identityNumber !== null
                    "
                  >
                    <div class="label">ID Card</div>
                    <div class="label-title">
                      {{ detail.passengers[0].identityNumber }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="box-addons mt-20">
              <div class="panel-group" id="accordion">
                <div class="panel panel-default">
                  <div class="panel-heading text-center">
                    <h4 class="panel-title">
                      <a class="btn btn-default" @click="publishInvoice()"
                        >Publish</a
                      >
                    </h4>
                  </div>
                  <div id="collapse1" class="panel-collapse collapse">
                    <div class="panel-body">
                      <p>
                        Lorem ipsum dolor sit, amet consectetur adipisicing
                        elit. Assumenda iusto doloremque cum ullam sit deleniti
                        perferendis praesentium facilis mollitia eveniet ipsam,
                        provident commodi voluptas voluptatum, modi consequatur.
                        Deleniti, perspiciatis sapiente.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-sm-5">
            <div class="price-detail-header">
              <div class="grand-total">
                <table class="table table-amount">
                  <thead>
                    <tr>
                      <th class="text-left">
                        <span>
                          <i class="ic-wallet mr-5 --blue"></i>
                        </span>
                        <!-- Amount to Pay -->
                        Pre-Booking
                      </th>
                      <th class="text-right">
                        <!-- {{ detail.currencyCode }} -->
                        <!-- {{ printMoney(detail.grandTotal) }} -->
                        <!-- {{ printMoney(totalCost) }} -->
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td class="text-left">Base</td>
                      <td class="text-right">
                        {{ printMoney(detail.baseFare) }}
                      </td>
                    </tr>
                    <tr v-if="detail.surchargeTotal > 0">
                      <td class="text-left">Surcharge</td>
                      <td class="text-right">
                        {{ printMoney(detail.surchargeTotal) }}
                      </td>
                    </tr>
                    <tr v-if="detail.ancillaryTotal > 0">
                      <td class="text-left">Ancillary</td>
                      <td class="text-right">
                        {{ printMoney(detail.ancillaryTotal) }}
                      </td>
                    </tr>
                    <tr v-if="detail.ancillaryTotal > 0">
                      <td class="text-left">Sub Total</td>
                      <td class="text-right">
                        {{ printMoney(detail.bookingTotal) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="reservation-button">
                  <div class="dropdown" v-if="!hasPaid">
                    <button
                      class="btn btn-default dropdown-toggle"
                      type="button"
                      id="dropdownMenu1"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="true"
                    >
                      Pay now
                      <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
                      <li>
                        <a
                          @click="payWithDeposit()"
                          v-if="detail.paymentConfig.isEnableCorporateAccount"
                        >
                          Corporate Account
                        </a>
                        <a
                          @click="payWithCreditCard()"
                          v-if="detail.paymentConfig.isEnablePaymentGateway"
                        >
                          Credit Card
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="grand-total">
                <table class="table table-amount">
                  <thead>
                    <tr>
                      <th class="text-left">
                        <span>
                          <i class="ic-wallet mr-5 --blue"></i>
                        </span>
                        Extra Services
                      </th>
                      <th class="text-right">
                        <!-- {{ detail.currencyCode }}
                        {{ printMoney(remainingPayment) }} -->
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in reservationDetail.fareComponentsPostBooking"
                      :key="item.name"
                    >
                      <!-- <td class="text-center">{{ index + 1 }}</td> -->
                      <td class="text-left">{{ item.name }}</td>
                      <!-- <td>{{ item.currencyCode }} {{ item.rate }}</td>
                      <td>{{ item.quantity }}</td> -->
                      <td class="text-right">
                        {{ printMoney(item.quantity * item.rate) }}
                      </td>
                      <!-- <td class="text-center">
                        <div class="button-action-wrapper">
                          <button
                            class="btn btn-default"
                            type="button"
                            @click="bindModel(item)"
                          >
                            <span>Edit</span>
                          </button>
                          <button
                            class="btn btn-default"
                            type="button"
                            @click="confirmDelete(item)"
                          >
                            <i class="ic-close"></i>
                          </button>
                        </div>
                      </td> -->
                    </tr>
                    <tr>
                      <td class="text-left">Sub Total</td>
                      <td class="text-right">
                        {{ printMoney(remainingPayment) }}
                      </td>
                    </tr>
                    <!-- <tr>
                      <td class="text-left">Base</td>
                      <td class="text-right">
                        {{ printMoney(detail.baseFare) }}
                      </td>
                    </tr>
                    <tr v-if="detail.surchargeTotal > 0">
                      <td class="text-left">Surcharge</td>
                      <td class="text-right">
                        {{ printMoney(detail.surchargeTotal) }}
                      </td>
                    </tr>
                    <tr v-if="detail.ancillaryTotal > 0">
                      <td class="text-left">Ancillary</td>
                      <td class="text-right">
                        {{ printMoney(detail.ancillaryTotal) }}
                      </td>
                    </tr> -->
                    <!-- <tr v-for="(item, index) in detail.payments" :key="index">
                      <td class="text-left">
                        {{ item.label }}
                      </td>
                      <td class="text-right">{{ item.stringRate }}</td>
                    </tr> -->
                  </tbody>
                </table>
                <div class="reservation-button">
                  <div class="dropdown" v-if="!hasPaid">
                    <button
                      class="btn btn-default dropdown-toggle"
                      type="button"
                      id="dropdownMenu1"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="true"
                    >
                      Pay now
                      <span class="caret"></span>
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
                      <li>
                        <a
                          @click="payWithDeposit()"
                          v-if="detail.paymentConfig.isEnableCorporateAccount"
                          >Corporate Account</a
                        >
                        <a
                          @click="payWithCreditCard()"
                          v-if="detail.paymentConfig.isEnablePaymentGateway"
                          >Credit Card</a
                        >
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="reservation-summary--small">
              <div class="dropandpickup cRow">
                <div class="col-sm-6 plz">
                  <div class="location-pick-up" :title="pickUpLocation">
                    {{ pickUpLocation }}
                  </div>
                  <div class="row">
                    <div class="col-sm-5 prz">
                      <div class="rent-date">
                        {{ detail.pickUpDate.stringDate }}
                        {{ detail.pickUpDate.stringShortMonth }}
                      </div>
                    </div>
                    <div class="col-sm-7 text-right">
                      <div class="rent-time">
                        <i class="ic-time"></i>
                        {{ pickUpTime }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6 prz divider-left">
                  <div
                    class="location-drop-off text-right"
                    :title="dropOffLocation"
                  >
                    {{ dropOffLocation }}
                  </div>
                  <div class="row">
                    <div class="col-sm-5 prz">
                      <div class="rent-date">
                        {{ detail.dropOffDate.stringDate }}
                        {{ detail.dropOffDate.stringShortMonth }}
                      </div>
                    </div>
                    <div class="col-sm-7 text-right">
                      <div class="rent-time">
                        <i class="ic-time"></i>
                        {{ dropOffTime }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="type-car">{{ detail.className }}</div>

              <div class="row">
                <div class="col-sm-7">
                  <div class="capacity-seat">Pax Capacity</div>
                  <div class="capacity-baggage">Max-Baggage</div>
                </div>
              </div>

              <div class="price-summary">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="operation with-driver"></div>
                  </div>
                  <div class="col-sm-6 text-right">
                    <div class="label-price">
                      <span v-if="isAirportTransfer">Price</span>
                      <span v-else>Price for {{ rentDays }}</span>
                    </div>
                    <div class="price-value">
                      {{ detail.currencyCode }}
                      <!-- {{ printMoney(detail.grandTotal) }} -->
                      {{ printMoney(detail.grandTotal + remainingPayment) }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- .reservation-summary--small -->
            <a class="btn btn-primary hidden" @click="confirm()">CONFIRM</a>
          </div>
        </div>
      </div>
    </section>
    <!-- End: Content -->

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import numeral from "numeral";
import inquiryReservationService from "@/services/shop/reservation/inquiryReservationService.js";
import inquiryProviderJobService from "@/services/job/providerJob/inquiryProviderJobService.js";
import paymentService from "@/services/shop/paymentService.js";
import depositService from "@/services/master/deposit/depositSummaryService.js";
import settingService from "@/services/master/setting/settingService.js";

export default {
  data() {
    return {
      moneyFormat: null,
      detail: {},
      rentDays: null,
      isLoading: false,
      msg: "Please wait",
      reservationDetail: {
        booker: {},
        serviceType: "",
        code: "",
        reservationDate: {},
        passengers: [],
        pickUpDate: {},
        pickUpLocation: {},
        dropOffDate: {},
        dropOffLocation: {},
        className: "",
        paymentStatus: "",
        currencyCode: "",
        grandTotal: "",
        histories: [],
        fareComponents: [],
        fareComponentsSelling: [],
        fareComponentsBuying: [],
        fareComponentsPreBooking: [],
        fareComponentsPostBooking: [],
      },
      totalCost: 0,
      remainingPayment: 0,
    };
  },
  computed: {
    isDetailExist: function () {
      return this.detail !== null && this.detail !== undefined;
    },
    hasPaid: function () {
      return (
        this.isDetailExist &&
        this.detail.paymentStatus !== undefined &&
        this.detail.paymentStatus !== null &&
        (this.detail.paymentStatus.toLowerCase() === "complete" ||
          this.detail.remainingPayment === 0)
      );
    },
    pickUpLocation: function () {
      return this.isDetailExist &&
        this.detail.pickUpLocation !== undefined &&
        this.detail.pickUpLocation !== null
        ? this.detail.pickUpLocation.name
        : "";
    },
    dropOffLocation: function () {
      return this.isDetailExist &&
        this.detail.dropOffLocation !== undefined &&
        this.detail.dropOffLocation !== null &&
        this.detail.dropOffLocation.name !== this.pickUpLocation
        ? this.detail.dropOffLocation.name
        : "Same Location";
    },
    pickUpTime: function () {
      return (
        this.isDetailExist &&
        this.detail.pickUpDate.hour +
          ":" +
          (this.detail.pickUpDate.minute < 10
            ? this.detail.pickUpDate.minute + "0"
            : this.detail.pickUpDate.minute)
      );
    },
    dropOffTime: function () {
      return (
        this.isDetailExist &&
        this.detail.dropOffDate.hour +
          ":" +
          (this.detail.dropOffDate.minute < 10
            ? this.detail.dropOffDate.minute + "0"
            : this.detail.dropOffDate.minute)
      );
    },
    isAirportTransfer: function () {
      return (
        this.isDetailExist &&
        this.detail.serviceType !== "" &&
        this.detail.serviceType.toLowerCase() === "airporttransfer"
      );
    },
  },
  async created() {
    await this.getById();
  },
  methods: {
    async getById() {
      try {
        this.isLoading = true;
        this.detail = await inquiryReservationService.getById(
          this.$route.params.id
        );
        this.rentDays = this.detail.rentDays;
        this.moneyFormat = this.detail.moneyFormat;
        if (this.detail != null) {
          this.reservationDetail.booker = this.detail.booker;
          this.reservationDetail.histories = this.detail.histories;
          this.reservationDetail.pickUpLocation = this.detail.pickUpLocation;
          this.reservationDetail.dropOffLocation = this.detail.dropOffLocation;
          this.reservationDetail.pickUpDate = this.detail.pickUpDate;
          this.reservationDetail.dropOffDate = this.detail.dropOffDate;
          this.reservationDetail.code = this.detail.code;
          this.reservationDetail.className = this.detail.className;
          this.reservationDetail.serviceType = this.detail.serviceType;
          this.reservationDetail.reservationDate = this.detail.reservationDate;
          this.reservationDetail.passengers = this.detail.passengers;
          this.reservationDetail.paymentStatus = this.detail.paymentStatus;
          this.reservationDetail.currencyCode = this.detail.currencyCode;
          this.reservationDetail.grandTotal = this.detail.grandTotal;
          this.reservationDetail.bookingTotal = this.detail.bookingTotal;
          this.reservationDetail.histories = this.detail.histories;
          this.reservationDetail.fareComponents = this.detail.fareComponents;
          if (
            this.reservationDetail.fareComponents != null &&
            this.reservationDetail.fareComponents.length > 0
          ) {
            var fareComponents = Array.prototype.slice.call(
              this.reservationDetail.fareComponents,
              0
            );
            this.reservationDetail.fareComponentsPreBooking =
              fareComponents.filter(
                (f) => f.category == "Selling" && f.isPreBooking == true
              );
            this.reservationDetail.fareComponentsPostBooking =
              fareComponents.filter(
                (f) => f.category == "Selling" && f.isPreBooking == false
              );
          }
          this.calculateTotal();
        }
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    calculateTotal() {
      this.remainingPayment =
        this.reservationDetail.fareComponentsPostBooking.reduce(
          (accum, item) => accum + item.quantity * item.rate,
          0
        );
      this.totalCost =
        this.reservationDetail.grandTotal + this.remainingPayment;
    },
    async payWithDeposit() {
      try {
        this.isLoading = true;
        // TODO
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async payWithCreditCard() {
      try {
        this.isLoading = true;
        // TODO
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    // async openRDP() {
    //   try {
    //     this.isLoading = true;
    //     const summaryUrl = `${document.location.origin}/distribution/inquiry-reservation/${this.detail.id}`;
    //     const notifyUrl = `${process.env.VUE_APP_BASE_API}/api/shop/payments/public/reddot/notify`;
    //     const response = await paymentService.rdpFirstPhase({
    //       reservationId: this.detail.id,
    //       reservationCode: this.detail.code,
    //       totalAmount: this.detail.remainingPayment,
    //       notifyUrl: notifyUrl,
    //       redirectUrl: summaryUrl,
    //       backUrl: summaryUrl,
    //       currencyCode: this.detail.currencyCode,
    //     });
    //     if (response && response.isSuccess) {
    //       window.open(response.data.payment_url, "_self");
    //     } else {
    //       this.$notification.error("Failed redirecting to payment page.");
    //     }
    //   } catch (error) {
    //     if (error.errors) {
    //       for (let index = 0; index < error.errors.length; index++) {
    //         this.$notification.error(error.errors[index], { title: "Error" });
    //       }
    //     }
    //   } finally {
    //     this.isLoading = false;
    //   }
    // },
    printMoney(value) {
      return this.moneyFormat
        ? numeral(value).format(this.moneyFormat.decimalFormat)
        : value;
    },
    async publishInvoice(value) {
      try {
        this.isLoading = true;
        const response = await inquiryProviderJobService.publishInvoice({
          inquiryReservationId: this.detail.id,
          providerId: this.detail.providerId,
        });
        this.$notification.success("Successfully Invoiced", {
          title: "Success",
        });
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/reservation/inquiry/ReservationInvoice.vue